import ProxyBase from './../../../../core/proxies/ProxyBase'

class CompanyProfileProxy extends ProxyBase {
  getCompanyHighlight(params) {
    return this.get('CompanyProfile/CompanyHightlight', params)
  }

  getCompanyInfoDetail(params) {
    return this.get('CompanyProfile/CompanyInfoDetail', params)
  }

  exportCompanyOverview(params) {
    return this.post(
      'CompanyProfile/CompanyOverview/Export',
      params,
      {},
      'download',
    )
  }

  exportIndustry(params) {
    return this.post(
      'CompanyProfile/Classification/Export',
      params,
      {},
      'download',
    )
  }

  exportBoardOfDirector(params) {
    return this.post(
      'CompanyProfile/BoardOfDirector/Export',
      params,
      {},
      'download',
    )
  }

  exportBoardOfManagement(params) {
    return this.post(
      'CompanyProfile/BoardOfManagement/Export',
      params,
      {},
      'download',
    )
  }
}

export default new CompanyProfileProxy()
